import axios, {
  AxiosInstance,
  AxiosPromise,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';

const getGenericApiClient = (config: AxiosRequestConfig = {}): AxiosInstance =>
  axios.create(config);

const use = <T>(request: AxiosPromise): Promise<T> =>
  new Promise((resolve, reject) => {
    request
      .then((result) => {
        const { data }: AxiosResponse = result;

        if (data.Success) {
          resolve(data.Data);
        } else {
          reject(data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

export const apiUtils = {
  getGenericApiClient,
  use,
};
